import RelativeTime from './relative-time.element.js';

export default RelativeTime;

RelativeTime.define('wje-relative-time', RelativeTime);
